<template>
    <div class="row">
        <b-card no-body class="col-12">
            <div class="d-inline-flex align-content-center">
                <h4 style="line-height: 35px;">Empresas relacionadas</h4>
            </div>
            <b-form class="row">
                <input-text class="col-12 col-md-6" label="Nome" v-model="form.nome" ref="nome" />
                <input-mask :mask="['(##) ####-####', '(##) #####-####']" class="col-12 col-md-6" label="Celular" v-model="form.celular" ref="celular"/>
                <input-mask type="cnpj" :mask="['##.###.###/####-##']" class="col-12 col-md-6" label="CNPJ" v-model="form.cnpjEmpresa" ref="cnpj"/>
                <input-select class="col-12 col-md-6" label="Nacionalidade" :options="nacionalidade" v-model="form.nacionalidade" ref="nacionalidade"/>
                <input-mask type="cpf" :mask="['###.###.###-##']" class="col-12 col-md-6" label="CPF" v-if="form.nacionalidade != 'Estrangeira'" v-model="form.cpf" ref="cpf" />
                <input-text class="col-12 col-md-6" label="Passaporte" v-if="form.nacionalidade == 'Estrangeira'" v-model="form.passaporte" ref="passaporte" />
                <input-select class="col-12 col-md-6" label="Titulação" :options="titulacao" v-model="form.titulacao" ref="titulacao" />
                <input-text class="col-12 col-md-6" label="Cidade" v-model="form.cidade" v-if="form.nacionalidade != 'Estrangeira'" ref="cidade" />
                <input-select class="col-12 col-md-6" label="Estado" :options="uf" v-model="form.uf" v-if="form.nacionalidade != 'Estrangeira'" ref="uf"/>
            </b-form>
        </b-card>

        <b-card no-body class="col-12 mt-3">
            <div class="d-inline-flex align-content-center">
                <h4 style="line-height: 35px;">Perfil</h4>
            </div>
            <b-form class="row">
                <input-checkbox
                    id="input-eh-administrador"
                    class="col-12 mb-3"
                    switch
                    text="É administrador?"
                    switchSize="lg"
                    v-model="ehAdministrador"
                />
            </b-form>
        </b-card>

        <div class="col-12 mt-3">
            <related-company @update-related-company="updateCompany" :companies="companies" />
        </div>

        <div class="col-12 form-inline justify-content-center mt-3">
            <b-button variant="outline-danger" class="mr-2" v-if="permissao.u" @click="disableUser()">
                <i class="fa-solid fa-user-slash mr-2"></i>
                Reprovar
            </b-button>
            <b-button variant="success" class="mr-2" v-if="permissao.u" @click="aproveUser()" :disabled="!companies.length">
                <i class="fa-solid fa-user-check mr-2"></i>
                Aprovar
            </b-button>
        </div>
    </div>
</template>
<script>
import UsuarioService from "@/common/services/usuario/usuario.service";
import AprovacaoService from "@/common/services/usuario/aprovacao.service";
import EmpresasService from "@/common/services/empresas/empresas.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputMask from "@/components/inputs/InputMask";
import InputCheckbox from "@/components/inputs/InputCheckbox";
import RelatedCompany from "@/components/form/RelatedCompany";
import jsonUF from "@/common/mock/UF.json";
import jsonNacionalidade from "@/common/mock/Nacionalidade.json";
import jsonTitulacao from "@/common/mock/Titulacao.json";
import Swal from "sweetalert2";

export default {
    props : ['usuario'],
    components: {
        InputText,
        InputSelect,
        InputMask,
        RelatedCompany,
        InputCheckbox
    },
    mounted() {
        if(!this.usuario)
            this.$router.push({ name: "aprovacao-usuario" });

        this.form = this.usuario;

        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            { titulo: this.$t("MENU.APROVACAO_USUARIOS"), to: {name: "aprovacao-usuario"} },
            { titulo: "Aprovar/Reprovar" }
        ]);

        EmpresasService.buscarPorId(this.usuario.empresaId)
            .then(response => {
                this.companies.push(response.data.data);
            });
    },
    data: () => ({
        form: {
            nome: "",
            cpf: "",
            dataNascimento: "",
            cnpj: "",
            nacionalidade: "",
            passaporte: "",
            titulacao: "",
            telefone: "",
            celular: "",
            cidade: "",
            uf: "",
        },
        companies: [],
        uf: jsonUF,
        nacionalidade: jsonNacionalidade,
        titulacao: jsonTitulacao,
        ehAdministrador: false
    }),
    methods: {
        validateState: function() {
            let arValidation = [];
            if(this.$refs.nacionalidade.value == 'Estrangeira') {
                arValidation.push(this.$refs.passaporte.valid());
            }
            else {
                arValidation.push(this.$refs.cidade.valid());
                arValidation.push(this.$refs.uf.valid());
                arValidation.push(this.$refs.cpf.valid());
            }

            arValidation.push(this.$refs.nome.valid());
            arValidation.push(this.$refs.nacionalidade.valid());
            arValidation.push(this.$refs.titulacao.valid());
            arValidation.push(this.$refs.celular.valid());

            return arValidation.filter((elem) => elem == false).length == 0;
        },

        updateCompany: function(company) {
            if(company.selected){
                this.companies.push(company.item);
            }else{
                this.companies.pop(company.item);
            }
        },

        disableUser: function() {
            Swal.fire({
                title: "Aviso",
                text: "Essa ação irá reprovar o acesso do usuário ao sistema. Deseja continuar?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: 'Continuar',
                denyButtonText: `Não`
            }).then((result) =>{
                if (result.isConfirmed) {
                    this.$store.dispatch(START_LOADING);
                    AprovacaoService.reprovarUsuario(this.form.id).then(() => {
                        Swal.fire({
                            title: "Sucesso",
                            text: "Usuário reprovado com sucesso",
                            icon: "success",
                        }).then(() =>{
                            this.$router.push({ name: "aprovacao-usuario" });
                        });
                        this.$store.dispatch("app/fetchSizeUsersToAprove");
                    }).catch(err => {
                        Swal.fire({
                            title: this.$t("GERAL.ERRO"),
                            text: err.response.data.errors,
                            icon: "error",
                        });
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            });
        },

        aproveUser: function(){
            Swal.fire({
                title: "Aviso",
                text: "Essa ação irá aprovar o acesso do usuário ao sistema e criar o registro de pessoa. Deseja continuar?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: 'Continuar',
                denyButtonText: `Não`
            }).then((result) =>{
                if (result.isConfirmed) {
                    if (this.validateState() == false) 
                        return;

                    let form = {
                        nome: this.form.nome,
                        cpf: this.form.cpf.replace(/[^0-9]/g, ""),
                        nacionalidade: this.form.nacionalidade,
                        passaporte: this.form.passaporte,
                        celular: this.form.celular.replace(/[^0-9]/g, ""),
                        endereco : {
                            cidade: this.form.cidade,
                            uf: this.form.uf,
                        },
                        titulacao: this.form.titulacao,
                        aprovacaoUsuarioId : this.form.id,
                        empresasId : this.companies.map(item => item.id)
                    };

                    this.$store.dispatch(START_LOADING);
                    AprovacaoService.aprovarUsuario(form).then((response) => {
                        let perfilForm = {
                            usuarioId: response.data.data,
                            ehAdministrador: this.ehAdministrador
                        };
                        
                        UsuarioService.editarPerfis(perfilForm).then(() =>{
                            Swal.fire({
                                title: "Sucesso",
                                text: "Usuário aprovado com sucesso",
                                icon: "success",
                            }).then(() =>{
                                this.$router.push({ name: "aprovacao-usuario" });
                            });

                            this.$store.dispatch("app/fetchSizeUsersToAprove");
                        }).catch((err) =>{
                            Swal.fire({
                                title: this.$t("GERAL.ERRO"),
                                text: err.response.data.errors,
                                icon: "error",
                            });
                        })
                    }).catch(err => {
                        Swal.fire({
                            title: this.$t("GERAL.ERRO"),
                            text: err.response.data.errors,
                            icon: "error",
                        });
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });

                } 
            });
        }
    },
    computed: {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('AprovacaoUsuario');
        },
    }
}
</script>
<style>
    .card {
        min-height: inherit !important;
    }
</style>